/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

$(document).ready(function () {
  jQuery(".ProductForm_option").click(function () {
    jQuery("html").toggleClass("visible-scroll");
  });

  function updateProductPage() {
    if ($(".ProductForm__Option").length) {
      if (location.search.indexOf("variant") != -1) {
        id = location.search.split("=");
        var option = $(".ProductForm__Option select").find(
          'option[value="' + id.pop() + '"]'
        );
      } else {
        var option = $(".ProductForm__Option select").find("option:selected");
      }

      history.pushState({}, null, "?variant=" + option.attr("value"));
      imageId = option.attr("data-image-id");

      selector = "";
      $.each($(".Popover__Value.is-selected"), function () {
        selector +=
          "[data-option" +
          $(this).attr("data-option-position") +
          '="' +
          $(this).attr("data-value") +
          '"]';
      });

      if ($(selector).attr("value") != $('[name="id"]').val()) {
        setTimeout(function () {
          $('[name="id"]')[0].value = $(selector).attr("value");
        }, 100);
      }

      $(".Product__Slideshow > div")
        .eq(0)
        .find("img")
        .attr("src", option.attr("data-image"))
        .attr("srcset", "")
        .parents(".Product__SlideItem")
        .attr(
          "data-image-position-ignoring-video",
          $("#Image" + imageId).index()
        );
    }
  }
  setTimeout(function () {
    updateProductPage();
  });

  $(".Popover__Value").on("click", function () {
    setTimeout(function () {
      var val = $(".ProductForm__Option select").find("option:selected").val();
      $(".Product__SlideshowNavScroller")
        .find('span[data-variant-id="' + val + '"]')
        .trigger("click");
      updateProductPage();
    }, 50);
  });

  var $carousel = $(".Product__Slideshow").flickity();

  $(".Product__SlideshowNavImage").on("click", function () {
    var d = $(this).data("dot-id");
    d = d - 1;
    $carousel.flickity("select", d);

    img = $(this).find("img").attr("src");
    $(".Product__Slideshow > div")
      .eq(0)
      .find("img")
      .attr("src", img.replace("160x", "600x"))
      .attr("srcset", "")
      .parents(".Product__SlideItem")
      .attr("data-image-position-ignoring-video", $(this).index());

    imgId = $(
      '.ProductForm__Option [data-image-id="' +
        $(this).attr("data-image-id") +
        '"]'
    );
    if (imgId.length) {
      val = imgId.attr("value");
      $(".ProductForm__Option select").val(val).change();
      history.pushState({}, null, "?variant=" + val);
      $(".Product__SlideshowNavScroller")
        .find('span[data-variant-id="' + val + '"]')
        .trigger("click");
      $(".ProductForm__SelectedValue").text(imgId.attr("data-option1"));
    }
  });

  $(".collection-slide").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "193px",
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 3,
          centerPadding: "140px",
        },
      },
      {
        breakpoint: 1200,
        settings: {
          centerPadding: "160px",
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          centerPadding: "140px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          centerPadding: "120px",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerPadding: "80px",
        },
      },
    ],
  });
});
